var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "hide-overflow", attrs: { flat: "", height: "100%" } },
    [
      _c(
        "v-layout",
        { staticStyle: { "margin-bottom": "50px" }, attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            {
              staticStyle: { margin: "24px 24px 0px 24px" },
              attrs: { xs12: "" },
            },
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _c(
                    "v-col",
                    [
                      _c("v-skeleton-loader", {
                        attrs: { type: "image", "max-height": "58" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("v-skeleton-loader", {
                        attrs: { type: "image", "max-height": "58" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("v-skeleton-loader", {
                        attrs: { type: "image", "max-height": "58" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto", "justify-self": "center" } },
                    [_c("v-skeleton-loader", { attrs: { type: "avatar" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c(
              "div",
              { staticClass: "pt-10" },
              _vm._l(12, function (i) {
                return _c(
                  "div",
                  { key: i, staticClass: "pt-1", attrs: { "two-line": "" } },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "px-4",
                      attrs: { type: "heading", "max-width": "400" },
                    }),
                    _c("v-skeleton-loader", {
                      staticClass: "px-4 pt-2",
                      attrs: { type: "text", "max-width": "1000" },
                    }),
                    _c("v-skeleton-loader", {
                      staticClass: "px-4",
                      attrs: { type: "text", "max-width": "600" },
                    }),
                    _c("v-divider"),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }